/**
 * The class that selects between the Barcode Detector API and the javascript version.
 *
 * There are two tools:
 * - the Barcode Detector API tool that works on Android on Chrome version 83+ (and Samsung Internet)
 * - the javascript library version ()
 */
class BarcodeScannerSelector {

    private readonly useBarcodeDetectionApi:boolean;
    private output:Output;

    private toolApi:BarcodeScanner;

    /**
     * The JS library
     */
    // @ts-ignore
    private toolJs:Html5QrcodeScanner;

    private config:BarcodeScannerSelectorSettings;

    /**
     * A collection of event names for this object. Event listeners must register agains only the
     * event names in this array.
     * @private
     */
    private legalEventNames:string[] = ["scanned"];

    /**
     * A collection of listeners to events. Each element is an object with the event name and the function to run.
     * Each function is given the instance of this class as argument.
     * @private
     */
    private eventListeners:BarcodeScannerSelectorEventObject[];

    /**
     *
     * @param isiOs If user should use OS support for barcodes
     * @param settings The configuration
     */
    public constructor(useBarcodeDetectionApi:boolean=false, settings:BarcodeScannerSelectorSettings=null) {
        this.eventListeners = []; // init

        // The default settings if not given
        const defaultSettings:BarcodeScannerSelectorSettings = {
            videoElementId: "video",
            videoContainerElementId: "video-container",
            beepCheckboxId:null,
            vibrationCheckboxId:null,
            logUrl:null,
            userAgent: "(no user agent string)",
            browser: "(unknown browser)",
            Html5QrcodeConstraints: {
                facingMode: "environment"
                //focusMode: "continuous"
            },
            userMediaOptions: {
                audio: false,
                video: {
                    facingMode: "environment",
                    width: {
                        min: 640,
                        ideal: 2048,
                        max: 3200
                    },
                    height: {
                        min: 480,
                        ideal: 1536,
                        max: 2400
                    },
                    advanced: [
                        {
                            zoom: 1.0
                        }
                    ]
                }
            }
        }

        // Merge config with default config
        this.config = {...defaultSettings, ...settings};

        this.useBarcodeDetectionApi = useBarcodeDetectionApi;
        this.output = new Output(this.config.vibrationCheckboxId, this.config.beepCheckboxId);
        this.initEventListeners();
    }

    /**
     * Initialize the event listeners
     * @private
     */
    private initEventListeners() {
        const self = this;
        if (this.useBarcodeDetectionApi) {
            // add click event on video to start reading the barcode/QR code
            const video = document.getElementById(this.config.videoElementId);
            video.addEventListener("click", () => {
                self.toolApi.captureImage();
            });
        }
    }

    /**
     * Play video
     */
    public play() {
        if (!this.useBarcodeDetectionApi) {
            // do nothing
        }
        else {
            const video = document.getElementById(this.config.videoElementId);
            const videoContainer = document.getElementById(this.config.videoContainerElementId);
            const elementWidth = $(video).width();                    // Get width of video element
            const ratio = this.toolApi.getTrack().getSettings().aspectRatio; // Get ratio between width and height of stream
            const height = Math.floor(elementWidth / ratio);            // Get new height of video element

            // Cut off 1/3rd on top and bottom of video stream
            const oneThirdHeight = Math.floor(height / 3);
            video.style.height = oneThirdHeight+"px";
            videoContainer.style.height = oneThirdHeight+"px";
        }
    }


    /**
     */
    public activate() {
        if (!this.useBarcodeDetectionApi) {
            this.toolJsSetupQrScanner();
            //$("#video").trigger("play");
        }
        else {
            this.toolApiSetupBarcodeScanner();
        }
    }


    /**
     * Set up the Html5QrcodeScanner object and add the on success event.
     * @private
     */
    private toolJsSetupQrScanner() {
        const self = this;
        const id = this.config.videoContainerElementId;

        // Calculate dimension of the QR box
        const qrwidth = Math.floor(document.body.clientWidth*.8);
        const qrheight = Math.floor(document.body.clientWidth*.3);

        const config = {
            fps: 5,
            qrbox: { width: qrwidth, height: qrheight },
            useBarCodeDetectorIfSupported: true,
            showTorchButtonIfSupported: true,
            showZoomSliderIfSupported: true,
            defaultZoomValueIfSupported: 2
        };
        //console.log(config);
        const constraints = this.config.Html5QrcodeConstraints;

        // @ts-ignore
        this.toolJs = new Html5Qrcode(id);
        this.toolJs.start(
            constraints,
            config,
            function(decodedText, decodedResult) {
                // https://github.com/mebjas/html5-qrcode
                // documentation? Read the source
                // https://github.com/mebjas/html5-qrcode/blob/master/src/html5-qrcode-scanner.ts
                self.toolJs.pause();
                self.output.beepOk();

                // The vibration does not detect or work on iOS, so disabling it at the moment
                // if (output.isVibrationSupported()) {
                //     alert("Yes");
                // }
                // else {
                //     alert("no");
                // }
                //output.vibrateOk();

                // Fire the scanned event to run callbacks
                self.fireEventListeners("scanned", { code: decodedText });
            },
            function(err) {
                // Since this will run when camera is running, We use this to start the getRunning track cap
            }
        ).then(()=> {
            if (false) {
                const capabilities = self.toolJs.getRunningTrackCapabilities();
                self.toolJs.applyVideoConstraints({
                    //colorTemperature: 0,
                    //exposureCompensation: 255
                })
            }
        });
    }

    /**
     *
     * @private
     */
    private toolApiSetupBarcodeScanner() {
        if (this.toolApi==undefined) {
            const self = this;
            const config = {
                id: this.config.videoElementId,
                debug: true,
                userOutputSelector: "#barcode-scanner-error-messages",
                //debug: false,
                okCallback: function(value) {
                    self.output.beepOk();
                    self.output.vibrateOk();
                    self.fireEventListeners("scanned", { code: value });
                },
                errorCallback: function() {
                    self.output.beepError();
                    self.output.vibrateNothingFound();
                },
                logCallback: function(text) {
                    self.log(text);
                },
                barcodeDetectorErrorMessage: "Detektering av strekkoder er ikke tilgjengelig på din enhet",
                mediaDevicesErrorMessage: "Tilkobling til webkamera er ikke tilgjengelig på din enhet",
                webcameraMissingErrorMessage: "Ingen webkamera er tilgjengelig på din enhet",
                httpErrorMessage: "Du besøker denne siden på HTTP, vennligst bytt til HTTPS for å aktivere webkamera"
            }
            this.log("Init webcamera - "+this.config.browser);
            this.log("User Agent: "+this.config.userAgent);

            this.toolApi = new BarcodeScanner(config);

            if (this.toolApi.hasErrors()) {
                let msgs = this.toolApi.getErrorMessages();
                let output = ""; // init
                // if one error message:
                if (msgs.length==1) { output = msgs[0]; }
                // if multiple error messages:
                else {
                    output = "<ul>";
                    this.toolApi.getErrorMessages().forEach((value:string) => {
                        output += "<li>" + value + "</li>";
                    });
                    output += "</ul>";
                }
                // Add ekstra information about support for barcode detector API
                output += "<br><br>Din enhet må ha støtte for webkamera og strekkoder for å bruke denne "+
                    "funksjonen. Dette er kun støttet av nyere Android-enheter foreløpig. "+
                    "<a href=\"https://caniuse.com/mdn-api_barcodedetector\" target=\"_blank\">Se liste over støttede "+
                    "enheter her</a>.";

                $("#barcode-scanner-error-messages").html(output);
            }
            else {
                this.output = new Output;
            }
        }

        this.toolApi.userMediaOptions = this.config.userMediaOptions;

        this.toolApi.start(function() {
            // This is the callback function when start is successfull
            // const constraints = {
            //     width: 300,
            //     height: 300,
            //     //focusMode: "manual",
            //     //focusDistance: 0.13,
            //     //frameRate: 10
            // }
        });
    }

    /**
     * Debugging to solve issues with webcamera.
     * This function is passed to the logCallback in BarcodeScanner and logging via ajax call.
     * If property logUrl in settings is not set (null), then this function will not log anything.
     * @param {string} text
     */
    public log(text, warning=false, error=false) {
        if (this.config.logUrl!=null) {
            if (warning) {
                console.warn(text);
            }
            else if (error) {
                console.error(text);
            }
            else {
                console.log(text);
            }

            $.ajax({
                url: this.config.logUrl,
                method: "PUT",
                data: text
            });
        }
    }


    /**
     * Stop the video
     */
    public stop() {
        if (this.useBarcodeDetectionApi) {
            this.toolApi.stop();
        }
    }

    /**
     * Register an event listener to given event.
     * @param event    An event name, legal names are "scanned"
     * @param listener A callback that takes this object as argument
     */
    public registerEventListener(event:string, listener:(BarcodeScannerSelector)=>void) {
        if (!this.legalEventNames.includes(event)) {
            throw new Error("Invalid event: "+event);
        }
        else {
            let object:BarcodeScannerSelectorEventObject = {
                event: event,
                callback: listener
            };
            this.eventListeners.push(object);
        }
    }


    /**
     *
     * @param event The event name
     * @param args  Arguments to send to event listener
     * @private
     */
    public fireEventListeners(event:string, args:{}={}) {
        if (!this.legalEventNames.includes(event)) {
            throw new Error("Illegal event name: "+event);
        }
        else {
            // iterate all event listeners and fire the ones having the same event name as given
            for (let i=0; i<this.eventListeners.length; i++) {
                const currentEvent = this.eventListeners[i];
                if (currentEvent.event==event) {
                    currentEvent.callback(this, args);
                }
            }
        }
    }

    /**
     * Check if we are using the Barcode Detection API
     */
    public isUsingBarcodeDetectionApi():boolean {
        return this.useBarcodeDetectionApi;
    }

    /**
     *
     */
    // @ts-ignore
    public getToolJs():Html5QrcodeScanner {
        return this.toolJs;
    }

}

/**
 * The object type for events
 */
type BarcodeScannerSelectorEventObject = {
    event:string,
    callback: (BarcodeScannerSelector, args:{}) => void
};


/*
 The settings object
 */
type BarcodeScannerSelectorSettings = {
    userMediaOptions?:MediaStreamConstraints,

    // This property is for the constraints for Html5Qrcode object. It requires either the id
    // of the camera or something that looks like userMediaOption.
    // See this: https://github.com/mebjas/html5-qrcode#scanning-without-cameraid
    Html5QrcodeConstraints?:
        { facingMode?:string|{ exact?:string} } |
        string,

    videoElementId: string,
    videoContainerElementId: string,
    vibrationCheckboxId?:string|null,    // The checkbox ID turning vibration on or off
    beepCheckboxId?:string|null,         // The checkbox ID turning beep on or off
    /* If logUrl is null, the log function will not log */
    logUrl:string|null, // The URL to send the logging
    browser:string,     // A description of the browser the user is using
    userAgent:string,   // The user agent string
}